<template>
  <div class="flex items-center">
    <button
      @click="toggleTheme"
      :title="isDarkMode ? '切换到浅色模式' : '切换到深色模式'"
    >
      <SunIcon v-if="!isDarkMode" class="w-5 h-5 text-indigo-500 mr-3" />
      <MoonIcon v-else class="w-5 h-5 text-indigo-500 mr-3" />
    </button>
  </div>
</template>

<script setup lang="ts">
import { onMounted, watch } from "vue";
import { useThemeStore } from "@/stores/theme";
import { SunIcon, MoonIcon } from "@heroicons/vue/24/solid";
import { storeToRefs } from "pinia";
import { configToaster } from "@/utils/toaster";

const store = useThemeStore();
const { isDarkMode } = storeToRefs(store);

/**
 * 切换主题并同步 toaster
 */
const toggleTheme = () => {
  store.toggleTheme();
  configToaster(isDarkMode.value);
};

// 监听外部变化（如 localStorage 同步）
watch(isDarkMode, (val) => {
  store.applyTheme();
  configToaster(val);
});

// 挂载时应用已持久化的主题偏好
onMounted(() => {
  store.applyTheme();
  configToaster(isDarkMode.value);
});
</script>
